import clsx from "clsx";
import React from "react";
import styles from "./Select.module.scss";

const Select = ({ children, isRtl, ...props }) => {
  return (
    <select {...props} className={clsx(styles.select, isRtl && styles.rtl)}>
      {children}
    </select>
  );
};

export default Select;
